import NumberIndicationAnalysisPage from './NumberIndicationAnalysisPage';

export default NumberIndicationAnalysisPage;